/* =================== CADASTRO =================== */
jQuery(document).ready(function ($) {
  var enviando_formulario = false;
  $("#form-cadastro").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = $("#cadastrar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      //hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          volta_submit();
          if (data == "ok") {
            $("#form-cadastro .campo").val(""); 
            if($('#retorno').val() != undefined){
              window.location.href = $('#retorno').val();
            } else {
              if($('input[type=radio][name="conta"]:checked').val() == 'clientes'){
                window.location.href = url_base+'cliente'+'/inicio';
              }else{
                window.location.href = url_base+'fornecedor'+'/inicio';
              }
            }
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
});

// ETAPA 1 - CADASTRO BÁSICO
if(param1 == 'criar-conta'){

  // FORMULARIO EM ETAPA
  $(function () {

    function enviaCod() {
      var obj = $('#form-cadastro');   
      var dados = new FormData(obj[0]);    
      $.ajax({
        type: "POST",
        url: url_base+'acoes/app/cadastro/cod_email_envia.php',
        data: dados,
        processData: false,
        cache: false,
        contentType: false,    
        success: function(resposta) {	
          //console.log(resposta);
        }
      });
    }

    $('#reeviar-cod').on('click', function(e){
      enviaCod();
      intervals.forEach(clearInterval);
      ativaTimer();
    }); 

    var $sections = $(".form-section");

    function navigateTo(index) {
      // Mark the current section with the class 'current'
      $sections.removeClass("current").eq(index).addClass("current");
      // Show only the navigation buttons that make sense for the current section:
      $(".btn-container .previous").toggle(index > 0);
      var atTheEnd = index >= $sections.length - 1;
      $(".btn-container .next").toggle(!atTheEnd);
      $(".btn-container [type=submit]").toggle(atTheEnd);

      if (index == 2) {
        //enviaCod();
        //intervals.forEach(clearInterval);
        //ativaTimer();
      }
      if (index == 2) {
        $(".btn-hide").hide();
        $(".fim").show();
      }
      /*if (index != 4) {
        $(".btn-hide").show();
      }
      if (index == 4 || index == 6) {
        $(".btn-hide").hide();
      }
      if (index == 4 || index == 5 || index == 6) {
        flexOf();
      } else {
        flexOn();
      } */
    }

    function curIndex() {
      // Return the current index by looking at which section has the class 'current'
      return $sections.index($sections.filter(".current"));
    }

    // Previous button is easy, just go back
    $(".btn-container .previous").click(function () {
      navigateTo(curIndex() - 1);
    });

    // Next button goes forward iff current block validates
    $(".btn-container .next").click(function () {
      $("#form-cadastro")
        .parsley()
        .whenValidate({
          group: "block-" + curIndex(),
        })
        .done(function () {
          // Verifica codigo
          if(curIndex() == 2){
            /* var obj = $('#form-cadastro');   
            var dados = new FormData(obj[0]);    
            $.ajax({
              type: "POST",
              url: url_base+'acoes/app/cadastro/cod_email_verifica.php',
              data: dados,
              processData: false,
              cache: false,
              contentType: false,    
              success: function(resposta) {	
                if(resposta == "ok"){
                  navigateTo(curIndex() + 1);
                }else{
                  showAlert('Erro', 'Tente novamente, código não correspondente.', 'error');
                }
              }
            }); */
            navigateTo(curIndex() + 1);
          }else{
            navigateTo(curIndex() + 1);
          }
        });
    });

    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function (index, section) {
      $(section)
        .find(":input")
        .attr("data-parsley-group", "block-" + index);
    });
    navigateTo(0); // Start at the beginning
  });

  $(function () {
    var emailComplete;
    $("#email").keyup(function (e) {
      emailComplete = $("#email").val();
      $("#email_user").val(emailComplete);
    });
  });

  var intervals = [];
  function ativaTimer() {
    $("#tempo").html('60');
    $("#frase-codigo").show();
    $("#reeviar-cod").hide();
    var counter = 60;
    var interval = setInterval(function () {
      counter--;
      if (counter <= 0) {
        clearInterval(interval);
        $("#frase-codigo").hide();
        $("#reeviar-cod").show();
        return;
      } else {
        $("#tempo").text(counter);
      }
    }, 1000);
    intervals.push(interval);
  }

  function flexOf() {
    $("#flexOff").addClass("centerOff");
  }

  function flexOn() {
    $("#flexOff").removeClass("centerOff");
  }

}
